import { lazy } from 'react';

// Each screen loads when its route first renders: imported directly, they
// (Settings above all) put most of the app in the initial bundle.
const V3Screens = {
  Home: lazy(() => import('./Home')),
  Content: lazy(() => import('./Content')),
  ContentIndex: lazy(() => import('./ContentIndex')),
  FavouriteIndex: lazy(() => import('./FavouriteIndex')),
  WorkspaceIndex: lazy(() => import('./WorkspaceIndex')),
  Workspace: lazy(() => import('./Workspace')),
  App: lazy(() => import('./App')),
  Settings: lazy(() => import('./Settings')),
};

export default V3Screens;
